import { Grid } from "@mui/material";
import { DateComponent, DateVariant } from "components/base/DateComponent";
import { isSameMinute } from "date-fns";
import PropertyRow from "./PropertyRow";
import { formatUserName, User } from "./userName";

export interface DataSourceVersionMetadata {
  version: string;
  isLive: boolean;
  comment: string;
  creationDate: Date;
  creator: User;
  modificationDate: Date;
  modifier: User;
}

// Minute precision matches the displayed date format
const wasModified = (version: DataSourceVersionMetadata) =>
  version.modifier.name !== version.creator.name ||
  !isSameMinute(version.modificationDate, version.creationDate);

export default function DataSourceVersionInfo({
  version
}: {
  version: DataSourceVersionMetadata;
}) {
  return (
    <Grid
      container
      columnSpacing={2}
      rowSpacing={0.5}
      data-testid="data-source-version-metadata"
    >
      <PropertyRow name="Comment">{version.comment || "-"}</PropertyRow>
      <PropertyRow name="Created at">
        <DateComponent
          date={version.creationDate}
          variant={DateVariant.SHORT_WITH_TIME}
        />
      </PropertyRow>
      <PropertyRow name="Created by">
        {formatUserName(version.creator)}
      </PropertyRow>
      {wasModified(version) && (
        <>
          <PropertyRow name="Modified at">
            <DateComponent
              date={version.modificationDate}
              variant={DateVariant.SHORT_WITH_TIME}
            />
          </PropertyRow>
          <PropertyRow name="Modified by">
            {formatUserName(version.modifier)}
          </PropertyRow>
        </>
      )}
    </Grid>
  );
}
